var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('validation-observer', {
    ref: "refFormReservation"
  }, [_c('HStack', {
    staticClass: "gap-2 py-50",
    attrs: {
      "end": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.isHideFunction ? 'outline-danger' : 'danger',
      "size": "sm"
    },
    on: {
      "click": _vm.toggleHideFunction
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("reservation.".concat(_vm.isHideFunction ? 'showFeature' : 'hideFeature'))) + " ")]), !_vm.isHideTakePhotoItineraries ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.onClickTakePhotoItineraries
    }
  }, [_c('HStack', {
    attrs: {
      "center": ""
    }
  }, [_c('IAmIcon', {
    attrs: {
      "icon": "camera",
      "size": "13"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('reservation.takePhotoItineraries')) + " ")], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('BookingTripDetail', {
    attrs: {
      "selected-trip": _vm.selectedTrip
    }
  }), _vm.isCombination ? _c('BookingPriceDetailCombination', {
    style: _vm.isShowPaymentCardLast ? 'order: 1' : '',
    attrs: {
      "selected-trip": _vm.selectedTrip,
      "data-search-flight": _vm.getSearchFlight,
      "passenger-data-to-add": _vm.sortedPassengers
    },
    on: {
      "update:passengerDataToAdd": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      },
      "update:passenger-data-to-add": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      }
    }
  }) : _vm.sortedPassengers && !_vm.isCreateGroupBooking ? _c('BookingPriceDetail', {
    style: _vm.isShowPaymentCardLast ? 'order: 1' : '',
    attrs: {
      "selected-trip": _vm.selectedTrip,
      "data-search-flight": _vm.getSearchFlight,
      "passenger-data-to-add": _vm.sortedPassengers,
      "draftBookingInfantPrice": _vm.draftBookingInfantPrice
    },
    on: {
      "update:passengerDataToAdd": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      },
      "update:passenger-data-to-add": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      },
      "handle-service": _vm.handleService,
      "handle-delete-service": _vm.handleDeleteService
    }
  }) : _vm._e(), _c('BookingPassengerDetail', {
    attrs: {
      "customer-id": _vm.customerId,
      "passenger-data-to-add": _vm.sortedPassengers,
      "data-search-flight": _vm.getSearchFlight,
      "selected-trip": _vm.selectedTrip,
      "is-create-group-booking": _vm.isCreateGroupBooking,
      "pax-data-group-booking": _vm.paxDataGroupBooking,
      "hasDiscountBsvVN1A": _vm.hasDiscountBsvVN1A,
      "hasApplyUpgradeClassVN1A": _vm.hasApplyUpgradeClassVN1A
    },
    on: {
      "update:passengerDataToAdd": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      },
      "update:passenger-data-to-add": function updatePassengerDataToAdd($event) {
        _vm.sortedPassengers = $event;
      },
      "deletePassenger": _vm.handleDeletePassenger,
      "multipleQuantityPaxChange": _vm.handleMultipleQuantityPaxChange,
      "updateCustomer": _vm.updateCustomer
    }
  }), !_vm.isProduction && _vm.selectedTrip.some(function (trip) {
    return trip.source === 'JQ';
  }) ? _c('BookingBundleDetail', {
    attrs: {
      "selected-trip": _vm.selectedTrip,
      "passenger-data-to-add": _vm.sortedPassengers
    }
  }) : _vm._e(), _vm.sortedPassengers && !_vm.isCreateGroupBooking && _vm.selectedTrip.some(function (trip) {
    return _vm.canBuyAncillary(trip.source, trip.clientId, trip.contentSource) || _vm.canBuySeat(trip.source, trip.clientId, trip.contentSource);
  }) ? _c('BookingAddonsDetail', {
    attrs: {
      "selectedTrip": _vm.selectedTrip,
      "getSearchFlight": _vm.getSearchFlight,
      "isCombination": _vm.isCombination,
      "passengerDataToAdd": _vm.sortedPassengers
    }
  }) : _vm._e(), _c('BCardGroup', {
    staticClass: "mb-50 mb-md-1",
    staticStyle: {
      "order": "2"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('BookingAgencyDetail', {
    attrs: {
      "agency-data": _vm.agencyData,
      "checkboxCustomerDataReplacePhoneAgencyData": _vm.checkboxCustomerDataReplacePhoneAgencyData,
      "checkboxCustomerDataReplaceEmailAgencyData": _vm.checkboxCustomerDataReplaceEmailAgencyData,
      "is-role-f1": _vm.isRoleF1,
      "enable-send-employee-mail-airline": _vm.enableSendEmployeeMailAirline,
      "check-send-employee-mail-airline": _vm.checkSendEmployeeMailAirline,
      "is-collapsed": _vm.isCollapsedAgencyAndContactDetail
    },
    on: {
      "update:agencyData": function updateAgencyData($event) {
        _vm.agencyData = $event;
      },
      "update:agency-data": function updateAgencyData($event) {
        _vm.agencyData = $event;
      },
      "update:checkboxCustomerDataReplacePhoneAgencyData": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-phone-agency-data": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkboxCustomerDataReplaceEmailAgencyData": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-email-agency-data": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "update:checkSendEmployeeMailAirline": function updateCheckSendEmployeeMailAirline($event) {
        _vm.checkSendEmployeeMailAirline = $event;
      },
      "update:check-send-employee-mail-airline": function updateCheckSendEmployeeMailAirline($event) {
        _vm.checkSendEmployeeMailAirline = $event;
      },
      "toggleCollapse": _vm.toggleIsCollapsedAgencyAndContactDetail
    }
  }), _c('BookingContactDetail', {
    attrs: {
      "customer-data": _vm.customerData,
      "checkboxCustomerDataReplacePhoneAgencyData": _vm.checkboxCustomerDataReplacePhoneAgencyData,
      "checkboxCustomerDataReplaceEmailAgencyData": _vm.checkboxCustomerDataReplaceEmailAgencyData,
      "is-role-f3": _vm.isRoleF3,
      "is-collapsed": _vm.isCollapsedAgencyAndContactDetail
    },
    on: {
      "update:customerData": function updateCustomerData($event) {
        _vm.customerData = $event;
      },
      "update:customer-data": function updateCustomerData($event) {
        _vm.customerData = $event;
      },
      "update:checkboxCustomerDataReplacePhoneAgencyData": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-phone-agency-data": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkboxCustomerDataReplaceEmailAgencyData": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-email-agency-data": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "resetAgencyData": _vm.resetAgencyData,
      "toggleCollapse": _vm.toggleIsCollapsedAgencyAndContactDetail
    }
  })], 1)], 1), !_vm.isHideFunction ? _c('div', {
    staticClass: "position-sticky",
    staticStyle: {
      "bottom": "0",
      "z-index": "18"
    }
  }, [_c('BRow', {
    staticClass: "bg-white py-1 rounded-lg"
  }, [_c('BCol', {
    class: "".concat(_vm.isMobileView ? 'mb-50' : '', " d-flex-center"),
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_vm.isShowCheckBoxSplitItineraries ? _c('BFormCheckbox', {
    attrs: {
      "disabled": _vm.isDisableSplitItineraries
    },
    model: {
      value: _vm.isSplitItineraries,
      callback: function callback($$v) {
        _vm.isSplitItineraries = $$v;
      },
      expression: "isSplitItineraries"
    }
  }, [_c('span', {
    staticClass: "font-weight-bolder font-medium-2"
  }, [_vm._v(_vm._s(_vm.$t('flight.splitItineraries')))])]) : _vm._e()], 1), _c('BCol', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('IAmOverlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: "".concat(_vm.isMobileView ? 'w-100 d-flex-between' : 'd-flex-center')
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(186, 191, 199, 0.15)',
      expression: "'rgba(186, 191, 199, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    class: "px-75 px-md-2 ".concat(!_vm.isMobileView ? 'mr-2' : ''),
    attrs: {
      "variant": "outline-secondary",
      "pill": ""
    },
    on: {
      "click": _vm.navigateBackHandle
    }
  }, [_c('span', {
    staticClass: "align-middle text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.Back')) + " ")])]), _vm.isVisiblePayLater ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "px-75 px-sm-2",
    attrs: {
      "variant": "warning",
      "pill": "",
      "disabled": !_vm.canAccess('booking.createBooking')
    },
    on: {
      "click": function click($event) {
        return _vm.handleValidateBooking(_vm.PAY_LATER);
      }
    }
  }, [_c('span', {
    staticClass: "align-middle text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.createBooking')) + " ")])]) : _vm._e(), _vm.isMobileView && _vm.isVisiblePayNow && !_vm.isSplitItineraries ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "px-75 px-md-2",
    attrs: {
      "variant": "outline-danger",
      "pill": "",
      "disabled": !_vm.canAccess('booking.createBooking')
    },
    on: {
      "click": function click($event) {
        return _vm.handleValidateBooking(_vm.PAY_NOW);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.paynow')) + " ")]) : _vm._e()], 1)])], 1), !_vm.isMobileView ? _c('BCol', {
    staticClass: "d-flex-center",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('IAmOverlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_vm.isVisiblePayNow && !_vm.isSplitItineraries ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "outline-danger",
      "pill": "",
      "disabled": !_vm.canAccess('booking.createBooking')
    },
    on: {
      "click": function click($event) {
        return _vm.handleValidateBooking(_vm.PAY_NOW);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.paynow')) + " ")]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('ModalCreateBookingConfirmPricePayNow', {
    attrs: {
      "booking-data": _vm.bookingDataToAdd
    },
    on: {
      "create-booking": _vm.createBookingHandle
    }
  }), _c('ModalCreateBookingConfirmPriceHold', {
    attrs: {
      "booking-data": _vm.bookingDataToAdd,
      "is-split-itineraries": _vm.isSplitItineraries,
      "hasDiscount20PercentVN1A": _vm.hasDiscount20PercentVN1A,
      "needSplitDiscountBsvVN1A": _vm.needSplitDiscountBsvVN1A
    },
    on: {
      "update:isSplitItineraries": function updateIsSplitItineraries($event) {
        _vm.isSplitItineraries = $event;
      },
      "update:is-split-itineraries": function updateIsSplitItineraries($event) {
        _vm.isSplitItineraries = $event;
      },
      "create-booking": _vm.createBookingHandle
    }
  }), _c('ModalShowGroupBooking', {
    attrs: {
      "data-group-booking": _vm.dataGroupBooking
    }
  }), _c('ModalCreateBookingErrorLengthPaxNameQH', {
    attrs: {
      "error-lists": _vm.errLengthNameList,
      "pay-type": _vm.payType
    },
    on: {
      "handleCreateBooking": _vm.modifyNameToCreateBooking
    }
  }), _c('ModalTakePhotoItineraries', {
    attrs: {
      "selected-trips": _vm.selectedTrip
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var isHidePrice = _ref.isHidePrice,
          isHidePassengers = _ref.isHidePassengers;
        return [_vm.isCombination ? _c('BookingPriceDetailCombination', {
          style: _vm.isShowPaymentCardLast ? 'order: 1' : '',
          attrs: {
            "selected-trip": _vm.selectedTrip,
            "data-search-flight": _vm.getSearchFlight,
            "passenger-data-to-add": _vm.sortedPassengers,
            "isTakePhoto": true,
            "isHidePrice": isHidePrice,
            "isHidePassengers": isHidePassengers
          },
          on: {
            "update:passengerDataToAdd": function updatePassengerDataToAdd($event) {
              _vm.sortedPassengers = $event;
            },
            "update:passenger-data-to-add": function updatePassengerDataToAdd($event) {
              _vm.sortedPassengers = $event;
            }
          }
        }) : _vm.sortedPassengers && !_vm.isCreateGroupBooking ? _c('BookingPriceDetail', {
          style: _vm.isShowPaymentCardLast ? 'order: 1' : '',
          attrs: {
            "selected-trip": _vm.selectedTrip,
            "data-search-flight": _vm.getSearchFlight,
            "passenger-data-to-add": _vm.sortedPassengers,
            "isTakePhoto": true,
            "draftBookingInfantPrice": _vm.draftBookingInfantPrice,
            "isHidePrice": isHidePrice,
            "isHidePassengers": isHidePassengers
          },
          on: {
            "update:passengerDataToAdd": function updatePassengerDataToAdd($event) {
              _vm.sortedPassengers = $event;
            },
            "update:passenger-data-to-add": function updatePassengerDataToAdd($event) {
              _vm.sortedPassengers = $event;
            },
            "handle-service": _vm.handleService,
            "handle-delete-service": _vm.handleDeleteService
          }
        }) : _vm._e()];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }